module.exports = __webpack_public_path__ + "static/media/saved_wreck_marker.a42bea48.svg";